const trackingUtils = require('../../modules/utils/tracking.utils.js');
const Slider = require('../../modules/ui/slider');
const filterViewMixin = require('./utils/filter.view.mixin');
const filterModelMixin = require('./utils/filter.model.mixin');
const filterModelProps = require('./utils/model_props');
const filterMixin = require('./utils/filter.mixin.js');
const updateFilter = function(fMetadata) {
    const filterModelStopDuration = fMetadata.filterModelStopDuration;
    const data = Odigeo._.pick(fMetadata, this.model.modelProps);
    const isFilterAvailable = this.isFilterAvailableWhenUpdate(fMetadata);

    if (filterModelStopDuration) {
        data.selectedStopDuration = filterModelStopDuration.selectedDuration;
    }

    this.model.set('selectedStopDuration', data.selectedStopDuration);
    this.updateSlider(data, isFilterAvailable);

    this.setIsFiltered(data);
};

Odigeo.defineWidget('stopover_duration_filter', Odigeo.Widget.extend(Odigeo._.defaults({
    modelClass: Odigeo.Model.extend(Odigeo._.defaults({
        modelProps: filterModelProps.stopoverDuration,
        defaults: {
            disabled: false,
        },
        getRequestModel: function() {
            return {
                selectedDuration: this.get('selectedStopDuration'),
            };
        },
        isFilterApplied: function() {
            var boundaryMaxStopDuration = this.get('boundaryMaxStopDuration');
            var selectedStopDuration = this.get('selectedStopDuration');
            var isDisabled = this.get('disabled');
            return !isDisabled && selectedStopDuration < boundaryMaxStopDuration;
        },
        getTagInfo: function() {
            return {
                selectedStopDuration: this.get('selectedStopDuration'),
            };
        },
    }, filterModelMixin)),
    viewClass: Odigeo.View.extend(Odigeo._.defaults({
        slider: {},
        selectors: {
            sliderContainer: '.stopover_duration_slider_container',
            selectedDurationLabel: '.selected_stopover_duration',
            filterSliderContainer: '.filter_slider_container',
        },
        resetFilter: function() {
            var data = this.model.toJSON();
            var noStopovers = data.maxStops < 1;
            var isFilterAvailable = !noStopovers && data.minStopDuration < data.maxStopDuration;

            data.selectedStopDuration = data.boundaryMaxStopDuration;
            this.model.set('selectedStopDuration', data.boundaryMaxStopDuration);
            this.updateSlider(data, isFilterAvailable);
            this.model.filterRequest(['stopDuration']);
        },
        updateFilter: function(idx, fMetadata) {
            if (this.widget.options.interactionsEnabled) {
                updateFilter.call(this, fMetadata);
            }
            this.setIsFiltered(fMetadata);
        },
        isFilterAvailableWhenUpdate(fMetadata) {
            const isDisabled = this.model.get('disabled');
            const noStopovers = fMetadata.maxStops < 1;

            return !isDisabled && !noStopovers &&
                fMetadata.boundaryMinStopDuration < fMetadata.boundaryMaxStopDuration &&
                fMetadata.selectedStopDuration <= fMetadata.boundaryMaxStopDuration;
        },
        setIsFiltered: function(fMetadata) {
            var idx = this.model.get('idx');
            var isFilterAvailable = fMetadata.maxStops > 0 && fMetadata.minStopDuration < fMetadata.maxStopDuration;
            var result = !this.model.get('disabled') &&
                (isFilterAvailable && fMetadata.maxStopDuration !== fMetadata.selectedStopDuration);

            Odigeo.trigger(this.widget.widgetType + ':filtersUpdated', idx, this.widget.name, result);
        },
        initFilter: function(data) {
            var noStopovers = data.maxStops < 1;
            var isFilterAvailable = !noStopovers && data.minStopDuration < data.maxStopDuration;
            this.initSlider(data, isFilterAvailable);
            if (!this.widget.options.interactionsEnabled && data.numFilteredResults > 0) {
                updateFilter.call(this, data);
            }
        },
        initSlider: function(data, isFilterAvailable) {
            this.slider = new Slider(this.$cachedSelectors.sliderContainer, {
                range: {
                    min: data.boundaryMinStopDuration,
                    max: data.boundaryMaxStopDuration,
                },
                values: [0],
                isDisabled: !isFilterAvailable,
                unit: this.widget.options.timeUnit,
                styleClass: 'od-ui-spaced-slider',
                reversed: this.widget.options.direction === 'rtl',
            });
            this.listenTo(this.slider, 'slider:move', this.updateDurationLabel);
            this.listenTo(this.slider, 'slider:invalidValues', this.updateDurationLabel);
            this.listenTo(this.slider, 'slider:change', this.notifyChange);
        },
        notifyChange: function(values) {
            this.model.set('selectedStopDuration', values[0]);
            this.model.filterRequest(['stopDuration']);
            this.sliderChangeTracking(values[0]);
        },
        updateSlider: function(data, isFilterAvailable) {
            this.slider.refresh({
                values: [data.selectedStopDuration],
                isDisabled: !isFilterAvailable,
            });
            this.updateDurationLabel(this.slider.opts.values);
        },
        sliderChangeTracking: function(value) {
            var label = 'stops_dur_' + Odigeo.Utils.pad(value, 2);
            trackingUtils.trackEvent('results_filters', label);
        },
        updateDurationLabel: function(values) {
            this.$cachedSelectors.selectedDurationLabel.html(
                '<span class="odf-b"> ' + this.widget.options.labelMaxStop + ':</span> <span>' +
                values[0] + this.slider.opts.unit + '</span>');
        },
    }, filterViewMixin)),

    bindEvents: function() {
        this.listenTo(this.model, 'change:disabled', function(model, disabled) {
            this.view.slider.refresh({
                isDisabled: disabled,
            });
        });
        this.listenTo(this.model, 'change:selectedStopDuration', this.triggerFilterChange);
        this.listenTo(this.model, 'change:disabled', this.triggerFilterChange);
    },
    updateMaxStopoversSelected: function(maxStopoversSelected) {
        this.model.set('disabled', maxStopoversSelected <= 0);
    },
    updateSlider: function() {
        this.view.slider.updateHandlers();
    },

    filterType: 'stopover-duration',
}, filterMixin)));
